import Suggestions from './Suggestions';

export default Suggestions;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Suggestions/index.js